// Teaser Top Mada pour la HomePage — affiche les 3 clips les plus votés cette semaine.
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fileStreamUrl } from "../lib/api";
import { Trophy, ArrowRight, Flame, Play } from "lucide-react";

export const TopMadaTeaser = () => {
  const [clips, setClips]   = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/topmada/videos")
      .then(({ data }) => {
        const sorted = [...(data.videos || [])]
          .sort((a, b) => (b.votes || 0) - (a.votes || 0))
          .slice(0, 3);
        setClips(sorted);
      })
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  if (!loaded || clips.length === 0) return null;

  const totalVotes = clips.reduce((s, c) => s + (c.votes || 0), 0);

  return (
    <section className="max-w-6xl mx-auto px-4 sm:px-6 my-10" data-testid="homepage-topmada-teaser">
      <div className="relative overflow-hidden rounded-3xl border border-amber-400/30 bg-gradient-to-br from-amber-900/40 via-red-900/30 to-zinc-900 p-6 md:p-8">
        <div className="absolute -top-12 -right-12 w-64 h-64 bg-amber-400/15 blur-3xl rounded-full" />
        <div className="relative grid md:grid-cols-[1fr,auto] gap-6 items-start">
          <div className="min-w-0">
            <div className="flex items-center gap-2 mb-2">
              <Trophy size={18} className="text-amber-300" />
              <span className="text-[10px] uppercase tracking-widest text-amber-300 font-bold">Top Mada · Clips officiels</span>
            </div>
            <h2 className="font-display font-black text-3xl md:text-4xl bg-gradient-to-r from-amber-200 via-amber-400 to-red-400 bg-clip-text text-transparent leading-none mb-2">
              Vote pour ton clip Malagasy préféré
            </h2>
            <div className="flex flex-wrap items-center gap-3 text-sm text-white/80">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-white/10 border border-white/15">
                <Flame size={12} className="text-red-400" />
                <strong className="text-white">{totalVotes}</strong> vote{totalVotes > 1 ? "s" : ""} en cours
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-amber-500/20 border border-amber-400/40 text-amber-100">
                🎬 {clips.length} clip{clips.length > 1 ? "s" : ""} en lice
              </span>
            </div>
          </div>
          <Link
            to="/topmada"
            data-testid="homepage-topmada-cta"
            className="inline-flex items-center gap-2 px-5 py-3 rounded-xl bg-gradient-to-r from-amber-400 to-red-500 hover:opacity-90 text-black font-black text-sm uppercase tracking-widest shrink-0 self-center md:self-start shadow-lg shadow-amber-500/20"
          >
            🗳️ Voter maintenant <ArrowRight size={14} />
          </Link>
        </div>

        {/* Top 3 clips teaser */}
        <div className="relative mt-6 grid grid-cols-3 gap-3">
          {clips.map((c, i) => (
            <Link
              key={c.video_id}
              to="/topmada"
              data-testid={`homepage-topmada-clip-${i + 1}`}
              className="group relative aspect-video rounded-xl overflow-hidden border border-white/10 hover:border-amber-400/50 bg-black"
            >
              {c.thumbnail ? (
                <img
                  src={c.thumbnail.startsWith("http") ? c.thumbnail : fileStreamUrl(c.thumbnail)}
                  alt={c.title}
                  className="absolute inset-0 w-full h-full object-cover opacity-90 group-hover:opacity-100 transition"
                  loading="lazy"
                />
              ) : (
                <div className="absolute inset-0 bg-gradient-to-br from-amber-700/40 to-red-700/40 flex items-center justify-center">
                  <Play size={28} className="text-amber-200/60" />
                </div>
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent" />
              <span className="absolute top-1.5 left-1.5 w-6 h-6 rounded-full bg-amber-400 text-black text-xs font-black flex items-center justify-center">{i + 1}</span>
              {c.votes > 0 && (
                <span className="absolute top-1.5 right-1.5 px-1.5 py-0.5 rounded-md bg-black/70 text-[10px] font-bold text-amber-200">
                  🗳️ {c.votes}
                </span>
              )}
              <p className="absolute bottom-1.5 left-2 right-2 text-[11px] font-bold leading-tight line-clamp-2">{c.title}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
